import React, { useState, useEffect } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import ImageContainer from "../image-container/ImageContainer";
import "../faqs/Faqs.css";
import Parser from "html-react-parser";
import LoginHeader from "../login/LoginHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import useLoading from "../../hooks/UseLoading";
import useAlert from "../../hooks/UseAlert";
import { Helmet } from "react-helmet";

export default function Faqs() {
  const [loggedStatus, setLoggedStatus] = useState("");
  const [faqContentText, setFaqContentText] = useState("");
  const [faqLabels, setFaqLabels] = useState([]);
  const [faqName, setFaqName] = useState("");
  var url = process.env.REACT_APP_API_URL;
  const [loader, showLoader, hideLoader] = useLoading();
  const navigate = useNavigate();
  const [alert, alert_notify] = useAlert();

  const getFaqLabels = () => {
    var faq_labels_url = "" + url + "/static_content/get_all_labels";
    var body = {
      page_name: "faq",
    };
    axios
      .post(faq_labels_url, body)
      .then((response) => {
        if (response.status === 200) {
          var data = response.data.Data.content;
          setFaqLabels(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getFaqLabels();

    var logged_status = localStorage.getItem("user_status");
    if (logged_status === "unlogged") {
      setLoggedStatus("unlogged");
    } else {
      setLoggedStatus("logged");
    }

    var faqs_url = "" + url + "/static_content/get_all_static_content";
    const body = { page_meta_key: "faq" };
    showLoader();
    axios
      .post(faqs_url, body)
      .then((response) => {
        if (response.status === 200) {
          var data = response.data.Data;
          var page_content = data.content.page_content;
          setFaqContentText(page_content);
          var page_name = data.content.page_name;
          setFaqName(page_name);
        }
        hideLoader();
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/login");
        } else {
          alert_notify("error", err.response.data.Error);
        }
        hideLoader();
      });
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Top Predictor | FAQs</title>
        <meta
          name="description"
          content="Get all your questions answered here. You can find the frequently asked questions on Top Predictor."
        />
      </Helmet>
      {loggedStatus === "logged" ? <Header /> : <LoginHeader />}
      <ImageContainer />
      <div className="faqs_container">
        <div className="page_content_center">
          <h2 className="faqs_header">FREQUENTLY ASKED QUESTIONS</h2>
          {Parser(faqContentText)}
        </div>
      </div>
      <Footer />
      {loader}
      {alert}
    </React.Fragment>
  );
}
